import {Injectable} from '@angular/core';
import {AbstractControl} from '@angular/forms';
import {HttpClient} from '@angular/common/http';
import {distinctUntilChanged, map} from 'rxjs/operators';
import {Observable, of} from 'rxjs';
import {environment} from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ValidatorService {

  constructor(public http: HttpClient) {
  }

  IBAN = (iban: string): Observable<object | null> => {
    if (!iban) {
      return of(null);
    } else {
      const val: string = iban.replace(' ', '');
      const url = `${environment.api.iban}validate/${val}`;
      if (!!val.match(/([A-Za-z]{2})*([0-9a-zA-Z]\s?){12,32}/)) {
        return this.http.get(url).pipe(
          distinctUntilChanged(),
          map((res: any) => {
            return (res.valid === true && res.messages.length === 0) ? null : {invalid: true};
          })
        );
      } else {
        return of({invalid: true});
      }
    }
  };

  getBIC = (iban: string): Observable<object | null> => {
    const url = `${environment.api.iban}validate/${iban}?getBIC=true`;
    return this.http.get(url).pipe(
      distinctUntilChanged(),
      map((res: any) => {
        return (res?.bankData?.bic) ? res : null;
      })
    );
  };
}
